<template>
	<button type="button" class="flex items-center justify-center px-4 py-3 rounded-sm border border-transparent rounded-sm shadow-sm text-base font-medium text-white bg-primary hover:shadow-lg transition-all">
        <slot></slot>
    </button>
</template>

<script>
	export default {

	}
</script>